// PWA shell barrel (Wave 2b-4). The architect calls initPwa(...) from
// main.ts at the MODULE INTEGRATION POINT in Wave 3; other modules import
// haptic() directly for touch feedback. The manifest + service worker half
// of the shell lives in vite.config.ts (vite-plugin-pwa) and needs no
// runtime wiring here — registerType 'autoUpdate' injects its own
// registration script at build time.

import { initWakeLock } from './wakeLock.js';
import { initRotateOverlay } from './rotateOverlay.js';

export { haptic, type HapticPattern } from './haptics.js';
export { initWakeLock, releaseWakeLock } from './wakeLock.js';
export { initRotateOverlay } from './rotateOverlay.js';

export interface PwaOptions {
  /** Live predicate for "a battle is on screen" — gates the rotate nag.
   *  Re-read continuously; cheap calls only. */
  isGameActive: () => boolean;
}

/** Wire the runtime PWA niceties: screen wake lock (held for the whole
 *  session — a dimming screen hurts the lobby QR-share moment too, and the
 *  lock auto-releases whenever the page is backgrounded) and the portrait
 *  rotate hint (gated on isGameActive). Call once at startup. */
export function initPwa(opts: PwaOptions): void {
  initWakeLock();
  initRotateOverlay(opts.isGameActive);
}
